import { FinancialOverview, OverviewItem, ProviderClaim } from '@enter/core';
import React, { useEffect, useState } from 'react';

interface IFinancialProps {
    claims: ProviderClaim[] | undefined;
}

export const Financial = ({ claims }: IFinancialProps) => {
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState<{
        total: OverviewItem;
        segments: OverviewItem[];
        goal: OverviewItem;
    }>({
        total: {
            name: 'Total Billing',
            amount: 0,
        },
        segments: [
            { name: 'Insurance Paid', amount: 0 },
            { name: 'Patient Paid', amount: 0 },
            { shortLabel: 'Remaining', name: 'Patient Remaining', amount: 0 },
        ],
        goal: {
            name: 'Accepted',
            amount: undefined,
        },
    });

    const calculateAmounts = async (fetchedClaims: ProviderClaim[]) => {
        const total = fetchedClaims.reduce((acc, claim) => {
            acc += Number(claim.chargeAmount?.amount) || 0;
            return acc;
        }, 0);

        const payerPaid = fetchedClaims.reduce((acc, claim) => {
            acc += Number(claim.payerAmount?.amount) || 0;
            return acc;
        }, 0);

        const patientPaid = fetchedClaims.reduce((acc, claim) => {
            acc += Number(claim.patientInvoicePaidAmount?.amount) || 0;
            return acc;
        }, 0);

        const patientAmount = fetchedClaims.reduce((acc, claim) => {
            acc += Number(claim.patientInvoiceAmount?.amount) || 0;
            return acc;
        }, 0);

        setData({
            total: {
                name: 'Total Billing',
                amount: total,
            },
            segments: [
                { name: 'Insurance Paid', amount: payerPaid },
                { name: 'Patient Paid', amount: patientPaid },
                {
                    shortLabel: 'Remaining',
                    name: 'Patient Remaining',
                    amount: Math.max(0, patientAmount - patientPaid),
                    showRefundWarning: true,
                },
            ],
            goal: {
                name: 'Accepted',
                amount: undefined,
            },
        });
    };

    useEffect(() => {
        if (!claims) {
            return;
        }

        (async () => {
            setLoading(true);

            await calculateAmounts(claims);

            setLoading(false);
        })();
    }, [claims]);

    return <FinancialOverview loading={!claims || loading} {...data} />;
};
